import { InitialPriceFilterState } from '@allesauto/utils/consts';

import {
  DELETE_PRICE_FILTER_RANGE,
  SET_PRICE_FILTER_RANGE,
} from '@/store/redux/actions/pages/pcp';
import { IReduxActionProps } from '@/store/redux/Utils';

export interface PriceFilterStateProps {
  key: string;
  max: number;
  min: number;
}

const PriceFilterState = (
  state: PriceFilterStateProps = InitialPriceFilterState,
  action: IReduxActionProps
) => {
  switch (action.type) {
    case SET_PRICE_FILTER_RANGE: {
      const range = action.payload as PriceFilterStateProps;

      return {
        ...state,
        ...range,
      };
    }
    case DELETE_PRICE_FILTER_RANGE: {
      const priceRangePayloadKey: keyof PriceFilterStateProps =
        (action.payload?.tag.key && 'key') ||
        (action.payload?.tag.min && 'min') ||
        (action.payload?.tag.max && 'max');

      const priceRanges = action.payload?.priceRanges;

      if (
        (priceRangePayloadKey === 'min' || priceRangePayloadKey === 'max') &&
        priceRanges &&
        priceRanges[state.key]
      ) {
        return {
          ...state,
          min: priceRanges[state.key].min,
          max: priceRanges[state.key].max,
        };
      }

      return {
        ...InitialPriceFilterState,
      };
    }
    default:
      return state;
  }
};

export default PriceFilterState;
